/**
 * Temporary file for convenient prefetching of data.
 *
 * To-do: Replace eventually with a end-to-end type-safe solution that integrates Tanstack Query with OpenAPI.
 */
import { queryClient } from '../lib/queryClient';
import { isAuthenticated } from '../utils/auth/helpers';
import { queryOptionsGetFeatures } from './shared/settingsApi';
import {
  queryOptionsGetWorkspace,
  queryOptionsGetWorkspacesPaginated,
} from './workspaces/workspaceApi';

// Fire-and-forget: QueryCache.onError already reports the failure, and the
// screen that needs the data shows its own error state.
const ignoreError = () => undefined;

export const prefetchWorkspace = (workspaceId: string) => {
  if (!isAuthenticated()) return;

  return queryClient
    .fetchQuery(queryOptionsGetWorkspace(workspaceId))
    .catch(ignoreError);
};

export const prefetchWorkspaces = () => {
  if (!isAuthenticated()) return;

  return queryClient
    .fetchQuery(queryOptionsGetWorkspacesPaginated())
    .then((data) => {
      /**
       * Populate the Query Cache with the fetched workspaces.
       * This will prevent individual refetches for these workspaces.
       */
      data?.items?.forEach((v) => {
        queryClient.setQueryData(queryOptionsGetWorkspace(v._id).queryKey, v);
      });

      return data;
    })
    .catch(ignoreError);
};

/**
 * Prefetch feature flags. This should be called early in the app lifecycle in index.tsx
 * so that feature flags are available before components render.
 */
export const prefetchFeatures = () => {
  if (!isAuthenticated()) return;

  return queryClient.fetchQuery(queryOptionsGetFeatures()).catch(ignoreError);
};
